import React, { useCallback, useEffect, useState, useTransition } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import CentralDashboardService from "../../services/centraldashboard.service";

// Fix marker icon issue (very common bug)
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

const busIcon = new L.Icon({
  iconUrl: "/icons/bus.png",
  iconSize: [35, 35], // size of icon
  iconAnchor: [17, 35], // point of icon that matches marker position
  popupAnchor: [0, -35],
});

function MapReport() {
  const [locations, setLocations] = useState([]);
  const [position, setPosition] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await CentralDashboardService.getLatLongForMap();

      setLocations(response.data.data);

      setPosition([
        Number(response.data?.data[0]?.Latitude),
        Number(response.data?.data[0]?.Longitude),
      ]);
      console.log("hhhee");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 30000);

    return () => clearInterval(interval);
  }, [fetchData]);

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Bus Tracking</div>
        <div className="graph-yearly-filter">
          <button
            type="button"
            className="filter-box"
            style={{ fontSize: "14px" }}
            onClick={fetchData}
          >
            ⟳ Refresh
          </button>
        </div>
      </div>
      {loading ? (
        <div className="h-100 d-flex justify-content-center align-items-center gap-2">
          <div
            class="spinner-border "
            style={{ color: "rgb(247, 177, 140)" }}
            role="status"
          >
            <span class="sr-only"></span>
          </div>
          <span>Loading...</span>
        </div>
      ) : (
        <MapContainer
          center={
            position.length ? position : [27.332450229441953, 88.6132078910866]
          } // central gangtok
          //   center={position}
          zoom={10}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            attribution="&copy; Aeon Software"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {locations?.map((loc) => (
            <Marker
              key={loc?.idx_Trackid_pk}
              position={[Number(loc?.Latitude), Number(loc?.Longitude)]}
            >
              <Popup>
                <b>{loc.get_vehicle?.VehNo}</b> <br />
                Lat: {Number(loc?.Latitude)}, Long: {Number(loc?.Longitude)}
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      )}
    </>
  );
}

export default MapReport;
